angular.module('impactx.util').directive('ixStopPropagation', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            if (attrs.ixStopPropagation) {
                element.bind(attrs.ixStopPropagation, function () {
                    return false;
                });
            }
        }
    };
});